export const editFormInput = (state, params) => {
	const { payload } = params;
	const { data, object, input, view } = payload;
	state[view][object].form[input].data = data;
	return state;
};

export const editImageInput = (state, params) => {
	const { payload } = params;
	const { data, object, input, view, size, source } = payload;
	state[view][object].form[input] = {
		...state[view][object].form[input],
		data,
		size,
		source
	};
	return state;
};

export const setImageSize = (state, params) => {
	const { payload } = params;
	const { object, input, view, size } = payload;
	state[view][object].form[input] = {
		...state[view][object].form[input],
		size
	};
	return state;
};

export const setInputValidation = (state, params) => {
	const { payload } = params;
	const { validation, object, input, view } = payload;
	state[view][object].form[input].validation = validation;
	return state;
};


export const toEditForm = (state, params) => {
	const { payload } = params;
	const { view, object } = payload;
	state[view][object].editable = true;
	return state;
};

export const setSelectedFile = (state, params) => {
	const { payload: selectedFile } = params;
	state.checkin2.files.selectedFile = selectedFile;
	return state;
};

export const setNextFile = (state, params) => {
	const { payload: nextFile } = params;
	state.checkin2.files.nextFile = nextFile;
	return state;
};

export default {};